export function formatToMillionBRL(value: number) {
  if (value > 1000000) {
    const truncatedValue = Math.floor(value / 1000000);
    return `R$ ${truncatedValue?.toLocaleString()} M`;
  }

  return value.toLocaleString("pt-BR", {
    style: "currency",
    currency: "BRL",
  });
}

export function formatToBRL(value: number | string) {
  // Converter para número e arredondar para 2 casas decimais para evitar precisão de ponto flutuante
  const numValue = typeof value === 'string' ? parseFloat(value) : value;
  const roundedValue = Math.round(numValue * 100) / 100; // Arredonda para 2 casas decimais
  
  return roundedValue.toLocaleString("pt-BR", {
    style: "currency",
    currency: "BRL",
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
}

export function formatCurrency(value: string): string {
  const onlyNums = value.replace(/[^0-9]/g, "");
  if (onlyNums === "") return "";
  const floatValue = Number.parseFloat(onlyNums) / 100;
  return floatValue.toLocaleString("pt-BR", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
}

export function formatPercentage(value: number | string, decimals = 2): string {
  const numValue = typeof value === "string" ? parseFloat(value) : value;
  return `${(numValue || 0).toFixed(decimals)}%`;
}

/**
 * Format a number using Brazilian locale (pt-BR)
 * @param value - Number to format
 * @returns Formatted string with thousands separators
 */
export function formatNumber(value: number): string {
  return new Intl.NumberFormat("pt-BR").format(value);
}
